var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 667,
    viewBox: "0 0 667 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_29",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 667,
    height: 667
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000365257H666.667V666.667H0V0.000365257Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.573 450.685C360.428 420.918 373.494 402.737 399.865 389.722C450.866 364.552 480.768 323.181 487.804 266.048C495.63 202.496 462.454 140.166 404.397 109.817C346.949 79.7863 276.09 88.849 228.878 132.265C145.326 209.1 163.337 338.966 265.382 389.565C292.541 403.03 304.737 422.11 303.818 452.3L302.932 573.574C302.726 580.534 302.792 593.793 290.569 593.793C277.033 593.793 278.065 580.641 277.848 573.72L277.581 454.438C278.286 433.144 271.27 420.808 251.517 411.161C179.432 375.962 142.498 302.87 152.737 220.176C161.466 149.666 220.056 87.9036 293.986 71.2716C382.204 51.4276 471.917 100.322 503.016 185.194C534.738 271.77 499.393 367.788 418.102 408.933C394.301 420.98 385.456 435.505 386.888 461.541L387.317 570.882C387.264 580.284 389.341 594.106 375.677 593.7C361.266 593.27 363.11 579.849 362.926 569.978L362.573 450.685Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.513 247.665C470.011 307.032 443.863 349.731 391.247 375.247C382.355 379.559 372.165 386.7 364.071 374.357C359.284 359.675 370.541 356.999 380.001 352.404C425.097 330.508 450.945 286.184 446.712 238.323C442.744 193.476 409.577 152.892 366.135 139.731C309.572 122.595 250.212 150.764 227.409 205.563C204.855 259.768 227.66 322.344 280.04 349.781C284.708 352.228 289.731 354.7 294.073 356.708C300.492 359.675 306.437 365.561 302.359 374.169C297.328 382.101 288.815 380.74 283.919 378.935C238.519 362.189 209.055 329.476 197.176 282.997C177.936 207.721 224.272 131.615 298.923 112.977C374.541 94.1001 450.469 140.639 468.812 217.515C471.248 227.721 471.436 238.465 472.513 247.665Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.923 248.364C403.755 208.322 371.11 175.948 331.744 176.781C293.476 177.593 260.871 210.245 260.391 248.237C259.902 286.875 293.535 320.55 332.594 320.529C372.67 320.506 404.094 288.714 403.923 248.364ZM334.498 151.498C387.579 152.084 431.334 196.962 430.559 250.028C429.77 304.059 384.555 347.391 330.075 346.327C276.891 345.289 235.306 301.291 235.835 246.621C236.354 193.08 280.104 150.897 334.498 151.498Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.298 380.876C320.583 373.661 317.997 359.676 332.365 359.676C345.763 359.676 344.957 373.323 345.057 380.236L345.038 621.945C344.935 629.097 345.763 642.177 332.91 642.144C319.802 642.891 319.575 631.045 319.641 620.591L320.298 380.876Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.333 32.1413C176.548 32.1413 127.566 80.0893 127.566 142.223",
    stroke: "#231F20",
    strokeWidth: 23.8693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.673 142.222C542.673 71.311 488.526 32.1403 429.906 32.1403",
    stroke: "#231F20",
    strokeWidth: 23.8693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.906 631.385C493.692 631.385 542.673 583.437 542.673 521.303",
    stroke: "#231F20",
    strokeWidth: 23.8693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.566 521.303C127.566 592.214 181.713 631.385 240.333 631.385",
    stroke: "#231F20",
    strokeWidth: 23.8693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.235 248.862C364.235 266.22 350.163 280.291 332.806 280.291C315.447 280.291 301.375 266.22 301.375 248.862C301.375 231.503 315.447 217.432 332.806 217.432C350.163 217.432 364.235 231.503 364.235 248.862Z",
    fill: "#F68712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.804 280.291C315.446 280.291 301.375 266.219 301.375 248.862C301.375 231.503 315.446 217.431 332.804 217.431C350.163 217.431 364.235 231.503 364.235 248.862C364.235 266.219 350.163 280.291 332.804 280.291ZM334.674 194.355C303.448 193.779 278.592 217.178 277.854 247.843C277.124 278.123 301.807 303.149 332.628 303.375C364.29 303.61 387.776 280.417 387.771 248.918C387.767 218.13 365.178 194.919 334.674 194.355Z",
    fill: "#231F20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothPic);
export default __webpack_public_path__ + "static/media/ToothPic.a57acd7d7520d08d5d07d179f18dd22b.svg";
export { ForwardRef as ReactComponent };